import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ItemFactBox from "./ItemFactBox";
import ItemImageBox from "./ItemImageBox";
import ItemCartBox from "./ItemCartBox";
import clsx from "clsx";

export default function UniversalItemDisplay({
  shoppingCart, sectionConfig={}, product, allProductSpecs
}) {
  const cartItem = findCartItem(shoppingCart, product);

  const { compact= false } = sectionConfig;

  const classes = [
    "item-display grid clearfix lg:pb-4 my-4",
    compact ? 'grid-cols-1' : 'lg:grid-cols-3'
  ]
  return <div className={clsx(classes)}>
    {!compact && <ItemImageBox product={product}/> }
    <ItemFactBox product={product} allProductSpecs={allProductSpecs}/>
    <ItemCartBox product={product} shoppingCart={shoppingCart} cartItem={cartItem}/>
  </div>;
}

UniversalItemDisplay.propTypes = {
  product: PropTypes.object.isRequired,
  application: PropTypes.object, // optional, for universal
  shoppingCart: PropTypes.object
}

function findCartItem(shoppingCart, product) {
  if (!shoppingCart || !product)
    return null;

  const cartIndex = _.keyBy(shoppingCart.cartItems, 'productId');

  return cartIndex[product.id];
}
